import { render, staticRenderFns } from "./transferOwnershipModal.vue?vue&type=template&id=5fac97ce&scoped=true&"
import script from "./transferOwnershipModal.vue?vue&type=script&lang=js&"
export * from "./transferOwnershipModal.vue?vue&type=script&lang=js&"
import style0 from "./less/transferOwnership.less?vue&type=style&index=0&id=5fac97ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fac97ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fac97ce')) {
      api.createRecord('5fac97ce', component.options)
    } else {
      api.reload('5fac97ce', component.options)
    }
    module.hot.accept("./transferOwnershipModal.vue?vue&type=template&id=5fac97ce&scoped=true&", function () {
      api.rerender('5fac97ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/modals/transferOwnershipModal.vue"
export default component.exports